var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8235 12.9974L9.80674 8.97768C10.5986 8.02799 11.0749 6.81434 11.0749 5.4888C11.0749 2.46472 8.59309 0.00585938 5.54032 0.00585938C2.48755 0.00585938 0 2.46759 0 5.49167C0 8.51575 2.48181 10.9746 5.53458 10.9746C6.83144 10.9746 8.025 10.5299 8.97182 9.78678L13.003 13.8179C13.2382 14.0532 13.5883 14.0532 13.8235 13.8179C14.0588 13.5827 14.0588 13.2326 13.8235 12.9974ZM1.17635 5.49167C1.17635 3.11601 3.13311 1.18508 5.53458 1.18508C7.93606 1.18508 9.89282 3.11601 9.89282 5.49167C9.89282 7.86732 7.93606 9.79825 5.53458 9.79825C3.13311 9.79825 1.17635 7.86445 1.17635 5.49167Z",
    fill: "#39695B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGreen);
export default __webpack_public_path__ + "static/media/search-green.f1354b6b171f4b488712124a104e4d6a.svg";
export { ForwardRef as ReactComponent };